var p=(i=>(i[i.wide=3]="wide",i[i.medium=4]="medium",i))(p||{});export{p as BreakAtElements};
//# sourceMappingURL=filter-wrapper.types.js.map
